import { render, staticRenderFns } from "./NoData.vue?vue&type=template&id=f67c6842&scoped=true&"
var script = {}
import style0 from "./NoData.vue?vue&type=style&index=0&id=f67c6842&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67c6842",
  null
  
)

export default component.exports